import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";

import { buscarUsuarios } from "../../services/http/usuariosService";

import services from "../../services";

import ListUsuario from "./ListUsuario";
import FormUsuario from "./FormUsuario";
import Header from "../../components/Header";

import "./styles.scss";
import { AutoComplete, Input } from "antd";
import { SearchOutlined } from "@mui/icons-material";
import { Divider } from "@mui/material";

const PageUsuario = () => {
  const { IdUser } = services.storage.getUser();
  const [idUsuario, setIdUsuario] = useState("");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    let timerId;
    if (nomeUsuario) {
      timerId = setTimeout(() => {
        listarUsuarios();
      }, 800);
    } else {
      listarUsuarios();
    }
    return () => {
      clearTimeout(timerId);
    };
  }, [nomeUsuario]);

  const listarUsuarios = (page, pageSize = 100) => {
   
    trackPromise(
      buscarUsuarios(page, pageSize, nomeUsuario)
        .then((res) => {
          if (!res.fail && res.data && res.data.lista) {
            let indexUser = res.data.lista.findIndex(
              (item) => item.id == IdUser
            );

            if (indexUser >= 0) {
              res.data.lista.splice(indexUser, 1);
            }

            setUsuarios(res.data.lista);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const showPerfil = (id) => {
    setIdUsuario(id);
  };
  const handleEnterPress = (e) => {
    setNomeUsuario(e);
  };

  const customFind = () => {
    setNomeUsuario(nomeUsuario);
  };
  const handleSearch = (searchText) => {
    setNomeUsuario(searchText);
  };

  return (
    <>
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />
      <div className="container ">

        <div className="row container-usuario">
          <ListUsuario usuarios={usuarios} setNomeUsuario={setNomeUsuario} nomeUsuario={nomeUsuario} handleEnterPress={handleEnterPress} customFind={customFind} handleSearch={handleSearch} showPerfil={showPerfil} />

          <div>
           
          </div>

          {idUsuario ? (
            <div className="col-md-8">
  
              <FormUsuario id={idUsuario} listarUsuarios={listarUsuarios} />
            </div>
          ) : (
            <div className="col-md-8">
              <div style={{ paddingBottom: "15px", borderBottom: "solid 1px #aaa", width:'100%', marginBottom:30 }}>
              <span className="titulo-perm">Usuários</span>
            </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PageUsuario;
